import { MicrosoftOnePageModel } from '../../../../../orchestration/microsoft/reports/models/microsoft-one-page-model';
import { OneDriveReportProfile } from '../../../../../models/microsoft/onedrive/profile/one-drive-report-profile';
import { OneDriveReportProfileRulesComputedDelegate } from '../../../../../models/microsoft/onedrive/profile/one-drive-report-profile-rules-computed-delegate';

export class OneDriveOnePageModel extends MicrosoftOnePageModel {
  resourceProfile: OneDriveReportProfile;
}
